import { isApiError, NETWORK_ERROR } from '../api/client';
import type { DictKey } from '../i18n/uk';

/** API error → dictionary key with a human explanation. Never shows raw server text. */
export function describeError(e: unknown): DictKey {
  if (!isApiError(e)) return 'err.generic';
  if (e.code === NETWORK_ERROR) return 'err.network';
  if (e.status === 429 || e.code === 'rate_limited') return 'err.rate_limited';
  if (e.status === 401) return 'err.unauthorized';
  if (e.status === 403) return 'err.forbidden';
  if (e.status === 404) return 'err.not_found';
  if (e.status === 422) return 'err.validation';
  return 'err.generic';
}
